import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';

export function BooleanValue({ deal, name, value, ...props }) {
  value = value == null ? deal[name] : value;

  // Map true/false to display labels; null leaves displayValue null and Value's falsy-guard
  // omits the row entirely.
  let displayValue;
  if (value === true) {
    displayValue = 'Yes';
  } else if (value === false) {
    displayValue = 'No';
  } else {
    displayValue = null;
  }

  return <Value {...props} name={name} value={displayValue} />;
}

BooleanValue.propTypes = {
  deal: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(BooleanValue);
